<template>
  <div>
    <div
      class="meeting-type-thumbnail meeting-type-thumbnail__image"
      :style="style"
    >
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeetingTypeThumbnail',
  props: {
    meetingType: {
      type: Object,
      required: true,
    },
  },
  computed: {
    style() {
      if (this.meetingType?.cover_photo) {
        const { focal_point_x, focal_point_y, image_url } = this.meetingType.cover_photo;
        return {
          backgroundImage: 'url(' + image_url + ')',
          backgroundSize: 'cover',
          backgroundPosition: `${focal_point_x}% ${focal_point_y}%`,
        };
      }
      return {};
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';
$tag-height: 26px;

.meeting-type-thumbnail {
  &__image {
    position: relative;
    border-radius: $border-radius;
    background-position: center center;
    background-size: auto 65%;
    background-repeat: no-repeat;
    background-color: var(
      --brand-color-with-opacity-03,
      rgba($light-bubblegum, 0.3)
    );
    object-fit: cover;
    transition: all 0.3s ease-in-out;
    height: 100%;

    &--active {
      background-color: $light-gray;
    }
  }
}
</style>
